exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._1TmDHBLk{margin-right:8px;height:18px;width:18px;border-radius:50%;display:inline-block;vertical-align:middle}._1TmDHBLk.JzgDOuFN{margin:0 15px;height:15px;width:15px}._2DPQFcfY :not(._2YVRQN3M) ._1TmDHBLk{vertical-align:middle;margin:0 .5em 0 0}._2DPQFcfY._2YVRQN3M ._1TmDHBLk{vertical-align:middle;margin:0 0 0 .5em}._2DPQFcfY .iCaZGdk2{vertical-align:middle}._2DPQFcfY._1_hYwOJK{font-weight:600;display:inline-block}.iCaZGdk2{color:#414141;line-height:16.8px;font-size:12px}", ""]);

// exports
exports.locals = {
	"color": "_1TmDHBLk",
	"big": "JzgDOuFN",
	"component": "_2DPQFcfY",
	"positionright": "_2YVRQN3M",
	"name": "iCaZGdk2",
	"bold": "_1_hYwOJK"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[hash:base64:8]"}!./node_modules/postcss-loader/lib!./node_modules/less-loader/dist!./src/note/categoryLabel/style.less
// module id = 1109
// module chunks = 1 2